import React from "react"
import { Col } from "react-bootstrap"

const PageListRenderer = ({
    pages,
    onPageChange
}: {
    pages: Record<string, any>[]
    onPageChange: Function
}): JSX.Element => {
    const pageWithoutIndication = pages?.filter((p) => p)
    return (
        <Col xs={12} lg={6} md={6} sm={12} className="text-end">
            <ul className="pagination react-bootstrap-table-page-btns-ul">
                {pageWithoutIndication.map((p) => (
                    <li className={p.active ? "active page-item" : "page-item"} title={p.page}>
                        <button onClick={() => onPageChange(p.page)} className="page-link">
                            {p.page}
                        </button>
                    </li>
                ))}
            </ul>
        </Col>
    )
}

export default PageListRenderer
